import { memo } from 'react';
import { SelectionList } from './SelectionList/SelectionList';
import { withMarketAccountSelection } from './withMarketAccountSelection';

export const MarketAccountSelectionList = memo(withMarketAccountSelection(SelectionList));
